import { render } from "./FireflyTag.vue?vue&type=template&id=62c9121d&scoped=true"
import script from "./FireflyTag.vue?vue&type=script&lang=js"
export * from "./FireflyTag.vue?vue&type=script&lang=js"

import "./FireflyTag.vue?vue&type=style&index=0&id=62c9121d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c9121d"]])

export default __exports__